export const getProductsInCartMap = (productCart, productList) => {
    const productsInCart = (productList || []).filter(p => (productCart || new Set()).has(p.id.toString()));

    let addOnProductsInCart = new Set();
    (productList || []).filter(p => (p.addOns || []).length).forEach(p => {
      p.addOns.forEach(addOn => {
        if ((productCart || new Set()).has(addOn.id.toString())) {
          addOn.groupType = p.groupType;
          addOnProductsInCart = addOnProductsInCart.add(addOn);
        }
      });
    });

    return productsInCart.concat([...addOnProductsInCart]);
  };

  export const productsCartActions = {
    50208: 'all',
    50224: 'all',
    50233: 'all',
    50234: 'all',
    50235: 'all',
    50236: 'all',
    50237: 'all',
    50238: 'all',
    50239: 'all',
    50240: 'apply',
    50241: 'apply',
    50242: 'apply',
    50244: 'contact',
    50245: 'contact',
    50246: 'contact',
    50247: 'contact',
    50248: 'contact',
    50249: 'contact',
    50250: 'all',
    50251: 'all',
    50252: 'all',
    50253: 'apply',
    50254: 'apply',
    50255: 'apply',
    50256: 'apply',
    50257: 'apply',
    50261: 'apply',
    50262: 'all',
    50263: 'apply',
    50264: 'contact',
    50265: 'contact',
    50266: 'contact',
    50267: 'all',
    50268: 'contact'
  };

export const getProductsInCartLists = (productList = [], key) => {
  if (typeof key !== 'string' || !productList) return [];

  if (productList.length === 0) return [];

  return productList.filter(e => productsCartActions[e.id] === key);
}